function padTo2Digits(num: number) {
  return num.toString().padStart(2, '0');
}

// examples: 12/31/2021, 01/01/2022
export default function getFullDate(date: Date) {
  return [
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
    date.getFullYear()
  ].join('/');
}
